import { render, staticRenderFns } from "./DummyTop.vue?vue&type=template&id=82c33814"
import script from "./DummyTop.vue?vue&type=script&lang=js"
export * from "./DummyTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports